import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconExpand45: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconExpand45"><Path d="M13.5 3.5H20.5V10.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 13.5V20.5H10.5" stroke="currentColor" strokeLinecap="square"/><Path d="M19.7031 4.29688L13.5 10.5" stroke="currentColor" strokeLinecap="square"/><Path d="M10.5 13.5L4.29688 19.7031" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconExpand45;
